import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { db, appId, storage } from "../firebase/firebaseConfig.jsx";
import {
  collection,
  query,
  orderBy,
  limit,
  startAfter,
  getDocs,
  addDoc,
  updateDoc,
  deleteDoc,
  doc,
  serverTimestamp,
  writeBatch,
} from "firebase/firestore";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { useToastMessage } from "../contexts/ToastMessageContext.jsx";
// // // import { useTranslation } from "react-i18next";   // Admin은 다국어 지원 불필요// Admin은 다국어 지원 불필요// Admin은 다국어 지원 불필요
import { adminNotificationService } from "../services/adminNotificationService.js";
import messageService from "../services/messageService.js";
// import { DataSanitizer } from "../utils/dataSanitizer.js"; // 삭제된 파일
import {
  Button,
  Modal,
  Form,
  Input,
  Typography,
  Card,
  List,
  Avatar,
  Divider,
  Tag,
  Row,
  Col,
  Tabs,
  Empty,
  DatePicker,
  Space,
  Radio,
  Collapse,
  Upload,
  Select,
  Switch,
  Checkbox,
  Pagination,
  Tooltip,
  Badge,
  Dropdown,
  Menu,
} from "antd";
import {
  ArrowLeftOutlined,
  ArrowRightOutlined,
  PlusOutlined,
  EditOutlined,
  DeleteOutlined,
  EyeOutlined,
  BellOutlined,
  ExclamationCircleOutlined,
  CheckCircleOutlined,
  FileTextOutlined,
  InfoCircleOutlined,
  CalendarOutlined,
  UserOutlined,
  SearchOutlined,
  FilterOutlined,
  ReloadOutlined,
  MoreOutlined,
  StarOutlined,
  HeartOutlined,
  ShareAltOutlined,
  DownloadOutlined,
  SettingOutlined,
  ThunderboltOutlined,
  FireOutlined,
  CrownOutlined,
} from "@ant-design/icons";
import {
  Bell,
  Plus,
  Search,
  Filter,
  RefreshCw,
  Edit,
  Trash2,
  Eye,
  X,
  Send,
  Calendar,
  User,
  FileText,
  Star,
  Heart,
  Share2,
  Download,
  Settings,
  MoreVertical,
  TrendingUp,
} from "lucide-react";
import dayjs from "dayjs";

const { Title, Text, Paragraph } = Typography;

// Modern CSS styles
const modernStyles = `
  .modern-tabs .ant-tabs-tab {
    padding: 10px 18px !important;
    border-radius: 10px 10px 0 0 !important;
    margin-right: 6px !important;
    background: transparent !important;
    border: none !important;
    transition: all 0.2s ease !important;
    color: #64748b !important;
  }
  
  .modern-tabs .ant-tabs-tab:hover {
    background: #f1f5f9 !important;
    color: #0f172a !important;
  }
  
  .modern-tabs .ant-tabs-tab-active {
    background: #ffffff !important;
    color: #0f172a !important;
    box-shadow: 0 -2px 8px rgba(15, 23, 42, 0.05) !important;
  }
  
  .modern-tabs .ant-tabs-ink-bar {
    display: none !important;
  }
  
  .modern-pagination .ant-pagination-item {
    border-radius: 8px !important;
    border: 1px solid #e2e8f0 !important;
    background: #ffffff !important;
    color: #475569 !important;
  }
  
  .modern-pagination .ant-pagination-item:hover {
    border-color: #94a3b8 !important;
    color: #0f172a !important;
  }
  
  .modern-pagination .ant-pagination-item-active {
    background: #0f172a !important;
    border-color: #0f172a !important;
    color: #ffffff !important;
  }
  
  .modern-pagination .ant-pagination-prev,
  .modern-pagination .ant-pagination-next {
    border-radius: 8px !important;
    border: 1px solid #e2e8f0 !important;
    background: #ffffff !important;
    color: #475569 !important;
  }
  
  .modern-pagination .ant-pagination-prev:hover,
  .modern-pagination .ant-pagination-next:hover {
    border-color: #94a3b8 !important;
    color: #0f172a !important;
  }
  
  .government-modal .ant-modal-content {
    border-radius: 16px !important;
    overflow: hidden !important;
    box-shadow: 0 20px 40px -12px rgba(15, 23, 42, 0.15) !important;
    background: #ffffff !important;
  }
  
  .government-modal .ant-modal-header {
    border-bottom: 1px solid #e2e8f0 !important;
  }
  
  .government-modal .ant-modal-body {
    padding: 20px !important;
  }
  
  .dark-select-dropdown .ant-select-dropdown {
    background: #ffffff !important;
    border: 1px solid #e2e8f0 !important;
    box-shadow: 0 12px 24px rgba(15, 23, 42, 0.08) !important;
  }
  
  .dark-select-dropdown .ant-select-item {
    color: #0f172a !important;
    background: transparent !important;
  }
  
  .dark-select-dropdown .ant-select-item:hover {
    background: #f8fafc !important;
    color: #0f172a !important;
  }
  
  .dark-select-dropdown .ant-select-item-option-selected {
    background: #e2e8f0 !important;
    color: #0f172a !important;
  }
  
  .dark-select-dropdown .ant-select-item-option-active {
    background: #f1f5f9 !important;
    color: #0f172a !important;
  }
  
  /* Input and TextArea styling */
  .government-modal .ant-input,
  .government-modal .ant-input:focus,
  .government-modal .ant-input-focused {
    background-color: #ffffff !important;
    border-color: #e2e8f0 !important;
    color: #0f172a !important;
    box-shadow: 0 0 0 2px rgba(15, 23, 42, 0.08) !important;
  }
  
  .government-modal .ant-input::placeholder {
    color: #94a3b8 !important;
  }
  
  .government-modal .ant-input:hover {
    border-color: #cbd5f5 !important;
  }
  
  .government-modal .ant-select-selector {
    background-color: #ffffff !important;
    border-color: #e2e8f0 !important;
    color: #0f172a !important;
  }
  
  .government-modal .ant-select-selection-item {
    color: #0f172a !important;
    background: transparent !important;
  }
  
  .government-modal .ant-select-selection-placeholder {
    color: #94a3b8 !important;
  }
  
  .government-modal .ant-select:hover .ant-select-selector {
    border-color: #94a3b8 !important;
  }
  
  .government-modal .ant-select-focused .ant-select-selector {
    border-color: #0f172a !important;
    box-shadow: 0 0 0 2px rgba(15, 23, 42, 0.12) !important;
  }
  
  .government-modal .ant-select-arrow {
    color: #64748b !important;
  }
  
  .government-modal .ant-select-clear {
    color: #64748b !important;
  }
  
  .line-clamp-2 {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
`;

// Inject styles
if (typeof document !== 'undefined') {
  const styleSheet = document.createElement("style");
  styleSheet.type = "text/css";
  styleSheet.innerText = modernStyles;
  document.head.appendChild(styleSheet);
}
const { TextArea } = Input;
const { TabPane } = Tabs;
const { Panel } = Collapse;

const AdminNoticePage = () => {
  const { showToastMessage } = useToastMessage();
  
  // 안전한 토스트 메시지 함수
  const safeShowToastMessage = (message, type = 'info') => {
    try {
      if (showToastMessage && typeof showToastMessage === 'function') {
        showToastMessage(message, type);
      } else {
        console.log(`[Toast] ${type.toUpperCase()}: ${message}`);
        // 기본 알림으로 대체
        alert(message);
      }
    } catch (error) {
      console.error('Toast message error:', error);
      console.log(`[Toast] ${type.toUpperCase()}: ${message}`);
    }
  };
  // // const { t } = useTranslation();  // Admin은 다국어 지원 불필요// Admin은 다국어 지원 불필요
  
  // State management
  const [notices, setNotices] = useState([]);
  const [infos, setInfos] = useState([]);
  const [boards, setBoards] = useState([]);
  const [loading, setLoading] = useState(false);
  const [activeTab, setActiveTab] = useState("notices");
  const [selectedItemIds, setSelectedItemIds] = useState([]);
  const [bulkDeleting, setBulkDeleting] = useState(false);
  
  // Pagination states
  const [noticePage, setNoticePage] = useState(1);
  const [infoPage, setInfoPage] = useState(1);
  const [boardPage, setBoardPage] = useState(1);
  const [noticeLastDoc, setNoticeLastDoc] = useState(null);
  const [infoLastDoc, setInfoLastDoc] = useState(null);
  const [boardLastDoc, setBoardLastDoc] = useState(null);
  const [noticeCursors, setNoticeCursors] = useState([]);
  
  // Enhanced pagination - 5 items per page for mobile
  const [pageSize, setPageSize] = useState(5);
  const [totalNotices, setTotalNotices] = useState(0);
  const [totalInfos, setTotalInfos] = useState(0);
  const [totalBoards, setTotalBoards] = useState(0);
  
  // Modal states
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [editingItem, setEditingItem] = useState(null);
  const [modalType, setModalType] = useState("notice");
  
  // Form states
  const [form] = Form.useForm();
  const [fileList, setFileList] = useState([]);
  const [uploading, setUploading] = useState(false);
  const [isUrgent, setIsUrgent] = useState(false);
  
  // Search and filter states
  const [searchTerm, setSearchTerm] = useState("");
  const [filterStatus, setFilterStatus] = useState("all");
  const [filterDate, setFilterDate] = useState(null);
  
  // Statistics states
  const [stats, setStats] = useState({
    totalNotices: 0,
    totalInfos: 0,
    totalBoards: 0,
    recentNotices: 0,
    recentInfos: 0,
    recentBoards: 0
  });


  // Constants
  const NOTICE_PAGE_SIZE = 10;
  const OTHER_PAGE_SIZE = 15;
  const noticeCollection = "notices";
  const infoCollection = "infos";
  const boardCollection = "boards";

  // Data fetching function
  const fetchData = async (collectionName, page, setData, lastDoc, setLastDoc, pageSize = OTHER_PAGE_SIZE) => {
    try {
      // 공지사항도 다른 admin 데이터와 동일한 경로 사용
      const collectionPath = `artifacts/${appId}/users/admin/${collectionName}`;
      
      // Notice items sorted by createdAt, other collections by updatedAt
      const orderField = collectionName === noticeCollection ? "createdAt" : "updatedAt";
      
      let q = query(
        collection(db, collectionPath),
        orderBy(orderField, "desc"),
        limit(pageSize)
      );

      let cursorToUse = lastDoc;
      // Cursor management for notice pagination
      if (collectionName === noticeCollection && page > 1) {
        cursorToUse = noticeCursors[page - 2] || null;
      }

      if (page > 1 && cursorToUse) {
        q = query(
          collection(db, collectionPath),
          orderBy(orderField, "desc"),
          startAfter(cursorToUse),
          limit(pageSize)
        );
      }

      const snap = await getDocs(q);
      const items = snap.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
        createdAt: doc.data().createdAt?.toDate?.() || new Date(),
        updatedAt: doc.data().updatedAt?.toDate?.() || doc.data().createdAt?.toDate?.() || new Date(),
      }));
      setData(items);
      
      if (snap.docs.length > 0) {
        const last = snap.docs[snap.docs.length - 1];
        setLastDoc(last);
        if (collectionName === noticeCollection) {
          setNoticeCursors((prev) => {
            const next = [...prev];
            next[page - 1] = last;
            return next;
          });
        }
      }
    } catch (error) {
      console.error("Data loading failed:", error);
      safeShowToastMessage("데이터 로드에 실패했습니다.", "error");
    }
  };

  // Statistics calculation
  const calculateStats = async () => {
    try {
      const now = new Date();
      const sevenDaysAgo = new Date(now.getTime() - 7 * 24 * 60 * 60 * 1000);
      
      // Get all notices
      const allNoticesQuery = query(
        collection(db, `artifacts/${appId}/users/admin/${noticeCollection}`),
        orderBy("createdAt", "desc")
      );
      const allNoticesSnap = await getDocs(allNoticesQuery);
      const allNotices = allNoticesSnap.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
        createdAt: doc.data().createdAt?.toDate?.() || new Date(),
        updatedAt: doc.data().updatedAt?.toDate?.() || doc.data().createdAt?.toDate?.() || new Date(),
      }));

      // Get all boards
      const allBoardsQuery = query(
        collection(db, `artifacts/${appId}/users/admin/${boardCollection}`),
        orderBy("createdAt", "desc")
      );
      const allBoardsSnap = await getDocs(allBoardsQuery);
      const allBoards = allBoardsSnap.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
        createdAt: doc.data().createdAt?.toDate?.() || new Date(),
        updatedAt: doc.data().updatedAt?.toDate?.() || doc.data().createdAt?.toDate?.() || new Date(),
      }));

      // Get all infos
      const allInfosQuery = query(
        collection(db, `artifacts/${appId}/users/admin/${infoCollection}`),
        orderBy("createdAt", "desc")
      );
      const allInfosSnap = await getDocs(allInfosQuery);
      const allInfos = allInfosSnap.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
        createdAt: doc.data().createdAt?.toDate?.() || new Date(),
        updatedAt: doc.data().updatedAt?.toDate?.() || doc.data().createdAt?.toDate?.() || new Date(),
      }));

      // Calculate recent items (last 7 days)
      const recentNotices = allNotices.filter(item => item.createdAt >= sevenDaysAgo).length;
      const recentBoards = allBoards.filter(item => item.createdAt >= sevenDaysAgo).length;
      const recentInfos = allInfos.filter(item => item.createdAt >= sevenDaysAgo).length;

      setStats({
        totalNotices: allNotices.length,
        totalInfos: allInfos.length,
        totalBoards: allBoards.length,
        recentNotices,
        recentInfos,
        recentBoards
      });
    } catch (error) {
      console.error("Statistics calculation failed:", error);
    }
  };


  // Load data on component mount
  useEffect(() => {
    loadInitialData();
    calculateStats();
  }, []);

  const loadInitialData = async () => {
    setLoading(true);
    try {
      await Promise.all([
        fetchData(noticeCollection, 1, setNotices, null, setNoticeLastDoc, NOTICE_PAGE_SIZE),
        fetchData(infoCollection, 1, setInfos, null, setInfoLastDoc),
        fetchData(boardCollection, 1, setBoards, null, setBoardLastDoc)
      ]);
    } catch (error) {
      console.error("Initial data loading failed:", error);
    } finally {
      setLoading(false);
    }
  };

  // Handle tab change
  const handleTabChange = (key) => {
    setActiveTab(key);
    setSelectedItemIds([]);
    setSearchTerm("");
    setFilterStatus("all");
    setFilterDate(null);
  };

  // Handle modal operations
  const showModal = (type, item = null) => {
    setModalType(type);
    setEditingItem(item);
    setIsModalVisible(true);
    
    if (item) {
      form.setFieldsValue({
        title: item.title || '',
        content: item.content || '',
        priority: item.priority || "normal",
        status: item.status || "active",
        category: item.category || "",
        tags: item.tags || [],
        sender: item.sender || "admin",
        isUrgent: item.isUrgent || false
      });
      setIsUrgent(item.isUrgent || false);
    } else {
      // 새 항목 생성 시 기본값 설정
      form.setFieldsValue({
        title: '',
        content: '',
        priority: 'normal',
        status: 'active',
        category: '',
        tags: [],
        sender: 'admin',
        isUrgent: false
      });
      setIsUrgent(false);
    }
    setFileList([]);
  };

  const handleModalCancel = () => {
    setIsModalVisible(false);
    setEditingItem(null);
    form.resetFields();
    setFileList([]);
  };

  // Handle form submission
  const handleSubmit = async (values) => {
    try {
      // 중복 제출 방지
      if (uploading) {
        console.log('⚠️ 이미 업로드 중입니다. 중복 제출 방지');
        return;
      }
      
      setUploading(true);
      console.log('📝 [ADMIN] 공지사항 생성 시작:', values.title);
      
      const collectionName = modalType === "notice" ? noticeCollection : 
                           modalType === "info" ? infoCollection : boardCollection;
      
      // 데이터 유효성 검사 및 정제
      const sanitizedData = {
        ...values,
        updatedAt: serverTimestamp()
      };

      if (!editingItem) {
        sanitizedData.createdAt = serverTimestamp();
        sanitizedData.author = "Admin";
        sanitizedData.views = 0;
        sanitizedData.likes = 0;
        
        // Frontend에서 올바른 sender 표시를 위한 authorType 설정
        if (sanitizedData.sender === 'myanmar_labor') {
          sanitizedData.authorType = 'ministry';
        } else {
          sanitizedData.authorType = 'admin';
        }
      }

      // Handle file uploads
      if (fileList.length > 0) {
        const uploadPromises = fileList.map(async (file) => {
          const storageRef = ref(storage, `notices/${Date.now()}_${file.name}`);
          const snapshot = await uploadBytes(storageRef, file);
          return await getDownloadURL(snapshot.ref);
        });
        sanitizedData.attachments = await Promise.all(uploadPromises);
      }

      let docRef;
      if (editingItem) {
        // 기존 공지사항 수정 (DBA 권고사항: 저장 기준 경로 사용)
        const oldStatus = editingItem.status;
        const newStatus = sanitizedData.status;
        
        // Frontend에서 올바른 sender 표시를 위한 authorType 설정
        if (sanitizedData.sender === 'myanmar_labor') {
          sanitizedData.authorType = 'ministry';
        } else {
          sanitizedData.authorType = 'admin';
        }
        
        const docPath = `artifacts/${appId}/users/admin/${collectionName}`;
        
        docRef = doc(db, docPath, editingItem.id);
        await updateDoc(docRef, sanitizedData);
        
        // 공지사항인 경우 상태 변경 알림 처리
        if (collectionName === noticeCollection) {
          const noticeData = { ...editingItem, ...sanitizedData, id: editingItem.id };
          await adminNotificationService.handleNoticeStatusChange(
            editingItem.id, 
            oldStatus, 
            newStatus, 
            noticeData
          );
        }
        
        safeShowToastMessage("공지사항이 성공적으로 업데이트되었습니다.", "success");
      } else {
        // 새 공지사항 생성
        const collectionPath = `artifacts/${appId}/users/admin/${collectionName}`;
        
        docRef = await addDoc(collection(db, collectionPath), sanitizedData);
        
        // 공지사항인 경우 새 공지사항 쪽지 발송
        if (collectionName === noticeCollection) {
          const noticeData = { ...sanitizedData, id: docRef.id };
          
          try {
            const messageResult = await messageService.sendNoticeToAllUsers(noticeData);
            
            if (messageResult.success) {
              safeShowToastMessage(`공지사항이 생성되었고 ${messageResult.sentCount}명의 사용자에게 쪽지가 발송되었습니다.`, "success");
            } else {
              safeShowToastMessage("공지사항은 생성되었지만 쪽지 발송에 실패했습니다.", "warning");
            }
          } catch (messageError) {
            console.error('Message sending error:', messageError);
            safeShowToastMessage("공지사항은 생성되었지만 쪽지 발송에 실패했습니다.", "warning");
          }
        } else {
          safeShowToastMessage("항목이 성공적으로 생성되었습니다.", "success");
        }
      }

      // Refresh data
      await loadInitialData();
      await calculateStats();
      handleModalCancel();
    } catch (error) {
      console.error("Save failed:", error);
      safeShowToastMessage(`저장에 실패했습니다: ${error.message}`, "error");
    } finally {
      setUploading(false);
    }
  };

  // Handle delete
  const handleDelete = async (item) => {
    try {
      const collectionName = activeTab === "notices" ? noticeCollection : 
                           activeTab === "infos" ? infoCollection : boardCollection;
      
      const docPath = `artifacts/${appId}/users/admin/${collectionName}`;
      
      await deleteDoc(doc(db, docPath, item.id));
      safeShowToastMessage("항목이 성공적으로 삭제되었습니다.", "success");
      
      // Refresh data
      await loadInitialData();
      await calculateStats();
    } catch (error) {
      console.error("Delete failed:", error);
      safeShowToastMessage("삭제에 실패했습니다.", "error");
    }
  };

  const toggleItemSelection = (itemId) => {
    setSelectedItemIds((prev) =>
      prev.includes(itemId) ? prev.filter((id) => id !== itemId) : [...prev, itemId]
    );
  };

  const handleBulkDelete = (type) => {
    const ids = [...selectedItemIds];
    if (ids.length === 0) return;
    const collectionName =
      type === "notice" ? noticeCollection : type === "info" ? infoCollection : boardCollection;
    Modal.confirm({
      title: "선택한 항목 삭제",
      content: `선택한 ${ids.length}개 항목을 삭제합니다. 삭제 후에는 되돌릴 수 없습니다.`,
      okText: "삭제",
      cancelText: "취소",
      okType: "danger",
      zIndex: 10010,
      onOk: async () => {
        setBulkDeleting(true);
        try {
          const docPath = `artifacts/${appId}/users/admin/${collectionName}`;
          for (let i = 0; i < ids.length; i += 450) {
            const batch = writeBatch(db);
            ids.slice(i, i + 450).forEach((id) => batch.delete(doc(db, docPath, id)));
            await batch.commit();
          }
          setSelectedItemIds([]);
          safeShowToastMessage(`${ids.length}개 항목을 삭제했습니다.`, "success");
          await loadInitialData();
          await calculateStats();
        } catch (error) {
          console.error("Bulk delete failed:", error);
          safeShowToastMessage("선택 항목 삭제에 실패했습니다.", "error");
        } finally {
          setBulkDeleting(false);
        }
      },
    });
  };

  // Handle pagination
  const handlePageChange = (page, type) => {
    setSelectedItemIds([]);
    if (type === "notice") {
      setNoticePage(page);
      fetchData(noticeCollection, page, setNotices, null, setNoticeLastDoc, NOTICE_PAGE_SIZE);
    } else if (type === "info") {
      setInfoPage(page);
      fetchData(infoCollection, page, setInfos, null, setInfoLastDoc);
    } else if (type === "board") {
      setBoardPage(page);
      fetchData(boardCollection, page, setBoards, null, setBoardLastDoc);
    }
  };

  // Filter data based on search and filter criteria
  const getFilteredData = (data) => {
    return data.filter(item => {
      const matchesSearch = !searchTerm || 
        item.title?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item.content?.toLowerCase().includes(searchTerm.toLowerCase());
      
      const matchesStatus = filterStatus === "all" || item.status === filterStatus;
      
      const matchesDate = !filterDate || 
        dayjs(item.createdAt).isSame(dayjs(filterDate), "day");
      
      return matchesSearch && matchesStatus && matchesDate;
    });
  };

  // Compact item row renderer
  const renderItemCard = (item, type, index) => {
    const getSenderName = (sender) => {
      switch(sender) {
        case 'admin': return 'Administrator';
        case 'myanmar_labor': return 'Myanmar Ministry of Labour';
        case 'system': return 'System';
        case 'operator': return 'System Operator';
        case 'support': return 'Support Team';
        default: return 'Administrator';
      }
    };

    const PRIORITY_STYLE = {
      urgent: 'bg-red-50 text-red-700 ring-red-200',
      high: 'bg-orange-50 text-orange-700 ring-orange-200',
      normal: 'bg-blue-50 text-blue-700 ring-blue-200',
      low: 'bg-emerald-50 text-emerald-700 ring-emerald-200',
    };
    const priority = PRIORITY_STYLE[item.priority] ? item.priority : 'normal';

    const TYPE_STYLE = {
      notice: { Icon: Bell, cls: 'bg-blue-50 text-blue-600' },
      info: { Icon: InfoCircleOutlined, cls: 'bg-emerald-50 text-emerald-600' },
      board: { Icon: FileText, cls: 'bg-violet-50 text-violet-600' },
    };
    const { Icon: TypeIcon, cls: typeCls } = TYPE_STYLE[type] || TYPE_STYLE.board;
    const isActive = item.status === 'active';

    return (
      <motion.div
        key={item.id}
        initial={{ opacity: 0, y: 6 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: Math.min(index, 10) * 0.015 }}
        className={`group relative flex items-start gap-3 rounded-lg border px-3 py-2.5 transition-colors ${
          selectedItemIds.includes(item.id)
            ? 'border-blue-300 bg-blue-50/60'
            : `bg-white hover:border-slate-300 hover:bg-slate-50/60 ${item.isUrgent ? 'border-red-200' : 'border-slate-200'}`
        }`}
      >
        {item.isUrgent && <span className="absolute left-0 top-0 h-full w-0.5 rounded-l-lg bg-red-500" aria-hidden />}

        <input
          type="checkbox"
          className="mt-2 h-4 w-4 shrink-0 cursor-pointer accent-slate-900"
          checked={selectedItemIds.includes(item.id)}
          disabled={bulkDeleting}
          onChange={() => toggleItemSelection(item.id)}
          aria-label={`${item.title || 'item'} 선택`}
        />

        <span className={`mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center rounded-md ${typeCls}`}>
          <TypeIcon className="h-3.5 w-3.5" />
        </span>

        <div className="min-w-0 flex-1">
          <div className="flex items-center gap-1.5">
            <h3
              className="truncate text-[13px] font-semibold text-slate-900 cursor-pointer hover:text-blue-700"
              onClick={() => showModal(type, item)}
            >
              {item.title}
            </h3>
            <span className={`shrink-0 rounded px-1.5 py-px text-[10px] font-semibold uppercase ring-1 ring-inset ${PRIORITY_STYLE[priority]}`}>
              {priority}
            </span>
            {item.isUrgent && priority !== 'urgent' && (
              <span className="shrink-0 rounded bg-red-500 px-1.5 py-px text-[10px] font-semibold text-white">URGENT</span>
            )}
            <span className={`shrink-0 inline-flex items-center gap-1 text-[10px] font-medium ${isActive ? 'text-emerald-600' : 'text-slate-400'}`}>
              <span className={`h-1.5 w-1.5 rounded-full ${isActive ? 'bg-emerald-500' : 'bg-slate-300'}`} />
              {isActive ? 'Active' : 'Inactive'}
            </span>
          </div>

          {item.content && (
            <p className="mt-0.5 line-clamp-1 break-words text-xs text-slate-500">{item.content}</p>
          )}

          <div className="mt-1 flex flex-wrap items-center gap-x-3 gap-y-1 text-[11px] text-slate-400">
            <span className="inline-flex items-center gap-1">
              <Calendar className="h-3 w-3" />
              {dayjs(item.createdAt).format('YYYY-MM-DD HH:mm')}
            </span>
            <span className="inline-flex items-center gap-1">
              <User className="h-3 w-3" />
              {getSenderName(item.sender)}
            </span>
            {item.tags && item.tags.length > 0 && (
              <span className="inline-flex flex-wrap items-center gap-1">
                {item.tags.slice(0, 3).map((tag, tagIndex) => (
                  <span key={tagIndex} className="rounded bg-slate-100 px-1.5 py-px text-[10px] text-slate-600">#{tag}</span>
                ))}
                {item.tags.length > 3 && (
                  <span className="text-[10px] text-slate-400">+{item.tags.length - 3}</span>
                )}
              </span>
            )}
          </div>
        </div>

        <div className="flex shrink-0 items-center gap-0.5 opacity-70 transition-opacity group-hover:opacity-100">
          <Tooltip title="Edit">
            <button
              onClick={() => showModal(type, item)}
              className="rounded p-1.5 text-slate-500 hover:bg-slate-100 hover:text-blue-600"
            >
              <Edit className="h-3.5 w-3.5" />
            </button>
          </Tooltip>
          <Tooltip title="Delete">
            <button
              onClick={() => handleDelete(item)}
              className="rounded p-1.5 text-slate-500 hover:bg-red-50 hover:text-red-600"
            >
              <Trash2 className="h-3.5 w-3.5" />
            </button>
          </Tooltip>
        </div>
      </motion.div>
    );
  };

  // Render statistics cards
  const renderStatsCards = () => (
    <Row gutter={[16, 16]} className="mb-6">
      <Col xs={24} sm={8}>
        <Card>
          <div className="text-center">
            <BellOutlined className="text-2xl text-blue-500 mb-2" />
            <Title level={3} className="mb-1">{stats.totalNotices}</Title>
            <Text type="secondary">Total Notices</Text>
            <div className="mt-1">
              <Text type="success">+{stats.recentNotices} this week</Text>
            </div>
          </div>
        </Card>
      </Col>
      <Col xs={24} sm={8}>
        <Card>
          <div className="text-center">
            <InfoCircleOutlined className="text-2xl text-green-500 mb-2" />
            <Title level={3} className="mb-1">{stats.totalInfos}</Title>
            <Text type="secondary">Total Infos</Text>
            <div className="mt-1">
              <Text type="success">+{stats.recentInfos} this week</Text>
            </div>
          </div>
        </Card>
      </Col>
      <Col xs={24} sm={8}>
        <Card>
          <div className="text-center">
            <FileTextOutlined className="text-2xl text-purple-500 mb-2" />
            <Title level={3} className="mb-1">{stats.totalBoards}</Title>
            <Text type="secondary">Total Boards</Text>
            <div className="mt-1">
              <Text type="success">+{stats.recentBoards} this week</Text>
            </div>
          </div>
        </Card>
      </Col>
    </Row>
  );

  const TAB_META = {
    notice: { key: 'notices', singular: 'notice', label: 'Notices', plural: 'notices', Icon: Bell, addLabel: 'New Notice' },
    info: { key: 'infos', singular: 'information', label: 'Information', plural: 'information', Icon: InfoCircleOutlined, addLabel: 'New Information' },
    board: { key: 'boards', singular: 'board post', label: 'Board Posts', plural: 'board posts', Icon: FileText, addLabel: 'New Post' },
  };

  const renderTabContent = (type, items, page, total) => {
    const meta = TAB_META[type];
    const filtered = getFilteredData(items);
    const EmptyIcon = meta.Icon;
    return (
      <div className="p-3">
        <div className="mb-3 flex flex-wrap items-center gap-2">
          <div className="relative min-w-[200px] flex-1 max-w-sm">
            <Search className="pointer-events-none absolute left-2.5 top-1/2 z-10 h-3.5 w-3.5 -translate-y-1/2 text-slate-400" />
            <Input
              placeholder={`Search ${meta.plural}...`}
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              allowClear
              className="h-8 rounded-md pl-8 text-[13px]"
            />
          </div>
          <span className="text-xs text-slate-500">
            {filtered.length} of {items.length}
          </span>
          <div className="ml-auto flex items-center gap-1.5">
            <Button
              size="small"
              icon={<RefreshCw className="h-3.5 w-3.5" />}
              onClick={loadInitialData}
              className="h-8 rounded-md border-slate-200 text-slate-600"
            >
              Refresh
            </Button>
            <Button
              type="primary"
              size="small"
              icon={<Plus className="h-3.5 w-3.5" />}
              onClick={() => showModal(type)}
              className="h-8 rounded-md border-0 bg-slate-900 hover:!bg-slate-800"
            >
              {meta.addLabel}
            </Button>
          </div>
        </div>

        {loading ? (
          <div className="flex items-center justify-center gap-2 py-10 text-sm text-slate-500">
            <div className="h-5 w-5 animate-spin rounded-full border-2 border-slate-200 border-t-slate-900" />
            Loading {meta.plural}...
          </div>
        ) : filtered.length === 0 ? (
          <div className="flex flex-col items-center justify-center py-10">
            <div className="mb-2 flex h-10 w-10 items-center justify-center rounded-full bg-slate-100">
              <EmptyIcon className="h-5 w-5 text-slate-400" />
            </div>
            <p className="text-sm font-medium text-slate-700">No {meta.plural} found</p>
            <p className="mb-3 text-xs text-slate-500">
              {searchTerm ? 'Try a different search term.' : `Create the first ${meta.singular} to get started.`}
            </p>
            {!searchTerm && (
              <Button
                type="primary"
                size="small"
                icon={<Plus className="h-3.5 w-3.5" />}
                onClick={() => showModal(type)}
                className="border-0 bg-slate-900 hover:!bg-slate-800"
              >
                {meta.addLabel}
              </Button>
            )}
          </div>
        ) : (
          <>
            {(() => {
              const visibleIds = filtered.map((item) => item.id);
              const selectedCount = visibleIds.filter((id) => selectedItemIds.includes(id)).length;
              const allSelected = visibleIds.length > 0 && selectedCount === visibleIds.length;
              return (
                <div className="mb-1.5 flex items-center justify-between gap-2 rounded-md bg-slate-50 px-3 py-1.5">
                  <label className="flex cursor-pointer items-center gap-2 text-xs text-slate-600">
                    <input
                      type="checkbox"
                      className="h-4 w-4 cursor-pointer accent-slate-900"
                      checked={allSelected}
                      ref={(el) => {
                        if (el) el.indeterminate = selectedCount > 0 && !allSelected;
                      }}
                      disabled={bulkDeleting}
                      onChange={() => setSelectedItemIds(allSelected ? [] : visibleIds)}
                    />
                    {selectedCount > 0 ? `${selectedCount}개 선택됨` : '전체 선택'}
                  </label>
                  {selectedCount > 0 && (
                    <button
                      type="button"
                      disabled={bulkDeleting}
                      onClick={() => handleBulkDelete(type)}
                      className="inline-flex h-7 items-center gap-1.5 rounded-md bg-red-600 px-2.5 text-xs font-semibold text-white hover:bg-red-700 disabled:opacity-50"
                    >
                      <Trash2 className="h-3.5 w-3.5" />
                      {bulkDeleting ? '삭제 중...' : `선택 삭제 (${selectedCount})`}
                    </button>
                  )}
                </div>
              );
            })()}
            <div className="space-y-1.5">
              {filtered.map((item, index) => renderItemCard(item, type, index))}
            </div>

            <div className="mt-3 flex flex-wrap items-center justify-between gap-2 border-t border-slate-100 pt-3">
              <div className="flex items-center gap-2 text-xs text-slate-500">
                <span>
                  {total === 0 ? 0 : ((page - 1) * pageSize) + 1}–{Math.min(page * pageSize, total)} of {total}
                </span>
                <Select
                  size="small"
                  value={pageSize}
                  onChange={setPageSize}
                  className="w-20"
                  options={[6, 12, 24, 48].map((n) => ({ value: n, label: `${n} / page` }))}
                  popupMatchSelectWidth={false}
                />
              </div>
              <Pagination
                size="small"
                current={page}
                total={total}
                pageSize={pageSize}
                onChange={(nextPage) => handlePageChange(nextPage, type)}
                showSizeChanger={false}
              />
            </div>
          </>
        )}
      </div>
    );
  };

  const STAT_ITEMS = [
    { type: 'notice', label: 'Notices', value: stats.totalNotices, recent: stats.recentNotices, Icon: Bell, cls: 'bg-blue-50 text-blue-600' },
    { type: 'info', label: 'Information', value: stats.totalInfos, recent: stats.recentInfos, Icon: InfoCircleOutlined, cls: 'bg-emerald-50 text-emerald-600' },
    { type: 'board', label: 'Board Posts', value: stats.totalBoards, recent: stats.recentBoards, Icon: FileText, cls: 'bg-violet-50 text-violet-600' },
  ];

  return (
    <div className="min-h-screen bg-slate-50 p-3">
      <style>{`
        .compact-notice-form .ant-form-item { margin-bottom: 12px; }
        .compact-notice-form .ant-form-item-label { padding-bottom: 4px; }
        .notice-tabs .ant-tabs-nav { margin-bottom: 0; }
        .notice-tabs .ant-tabs-tab { padding: 8px 0; font-size: 13px; }
      `}</style>

      {/* Header + Stats */}
      <div className="mb-3 rounded-xl border border-slate-200 bg-white px-4 py-3 shadow-sm">
        <div className="flex flex-wrap items-center justify-between gap-3">
          <div className="flex items-center gap-2.5">
            <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-slate-900">
              <FileText className="h-4 w-4 text-white" />
            </div>
            <div>
              <h1 className="text-[15px] font-semibold leading-tight text-slate-900">Notice Management</h1>
              <p className="text-[11px] leading-tight text-slate-500">Notices, information and board posts</p>
            </div>
          </div>

          <div className="flex flex-wrap items-center gap-2">
            {STAT_ITEMS.map(({ type, label, value, recent, Icon, cls }) => (
              <button
                key={type}
                type="button"
                onClick={() => handleTabChange(TAB_META[type].key)}
                className={`flex items-center gap-2 rounded-lg border px-2.5 py-1.5 text-left transition-colors ${
                  activeTab === TAB_META[type].key ? 'border-slate-400 bg-slate-50' : 'border-slate-200 hover:border-slate-300'
                }`}
              >
                <span className={`flex h-6 w-6 items-center justify-center rounded-md ${cls}`}>
                  <Icon className="h-3.5 w-3.5" />
                </span>
                <span>
                  <span className="block text-[10px] leading-tight text-slate-500">{label}</span>
                  <span className="flex items-baseline gap-1">
                    <span className="text-sm font-bold leading-tight text-slate-900 tabular-nums">{value}</span>
                    {recent > 0 && <span className="text-[10px] font-medium text-emerald-600">+{recent}/wk</span>}
                  </span>
                </span>
              </button>
            ))}
          </div>
        </div>
      </div>

      {/* Tabs */}
      <div className="overflow-hidden rounded-xl border border-slate-200 bg-white shadow-sm">
        <Tabs
          activeKey={activeTab}
          onChange={handleTabChange}
          className="notice-tabs"
          tabBarStyle={{ padding: '0 16px', margin: 0, background: '#f8fafc', borderBottom: '1px solid #e2e8f0' }}
          items={[
            { type: 'notice', items: notices, page: noticePage, total: totalNotices, count: stats.totalNotices },
            { type: 'info', items: infos, page: infoPage, total: totalInfos, count: stats.totalInfos },
            { type: 'board', items: boards, page: boardPage, total: totalBoards, count: stats.totalBoards },
          ].map(({ type, items, page, total, count }) => {
            const meta = TAB_META[type];
            const TabIcon = meta.Icon;
            return {
              key: meta.key,
              label: (
                <span className="flex items-center gap-1.5">
                  <TabIcon className="h-3.5 w-3.5" />
                  {meta.label}
                  <span className="rounded-full bg-slate-200 px-1.5 text-[10px] font-semibold text-slate-600 tabular-nums">{count}</span>
                </span>
              ),
              children: renderTabContent(type, items, page, total),
            };
          })}
        />
      </div>

      {/* Government Style Modal for creating/editing items */}
      <Modal
        title={
          <div className="flex items-center gap-2.5">
            <div className="w-8 h-8 bg-slate-900 rounded-lg flex items-center justify-center">
              {modalType === 'notice' ? <Bell className="w-4 h-4 text-white" /> :
               modalType === 'info' ? <InfoCircleOutlined className="w-4 h-4 text-white" /> :
               <FileText className="w-4 h-4 text-white" />}
            </div>
            <h3 className="text-[15px] font-semibold text-slate-900 capitalize">
              {editingItem ? `Edit ${TAB_META[modalType]?.singular || modalType}` : `Create ${TAB_META[modalType]?.singular || modalType}`}
            </h3>
          </div>
        }
        open={isModalVisible}
        onCancel={handleModalCancel}
        footer={null}
        width={760}
        className="government-modal"
        centered
        destroyOnClose
        styles={{
          header: {
            background: '#ffffff',
            borderBottom: '1px solid #e2e8f0',
            padding: '12px 16px',
            marginBottom: 0,
            borderRadius: '12px 12px 0 0'
          },
          body: {
            padding: '16px',
            background: '#ffffff',
            borderRadius: '0 0 12px 12px'
          },
          mask: {
            backgroundColor: 'rgba(15, 23, 42, 0.35)',
            backdropFilter: 'blur(4px)',
            zIndex: 10000
          }
        }}
        zIndex={10000}
      >
        <Form
          form={form}
          layout="vertical"
          className="compact-notice-form"
        >
          <Form.Item
            name="title"
            label={<span className="text-slate-700 font-medium">Title</span>}
            rules={[{ required: true, message: "Please enter title" }]}
          >
            <Input 
              placeholder="Enter title" 
              className="focus:border-slate-400 focus:ring-2 focus:ring-slate-200"
            />
          </Form.Item>

          <Form.Item
            name="content"
            label={<span className="text-slate-700 font-medium">Content</span>}
            rules={[{ required: true, message: "Please enter content" }]}
          >
            <TextArea 
              rows={5} 
              placeholder="Enter content" 
              className="focus:border-slate-400 focus:ring-2 focus:ring-slate-200"
            />
          </Form.Item>

          <Row gutter={12}>
            <Col xs={24} md={12}>
              <Form.Item name="sender" label={<span className="text-slate-700 font-medium">Sender</span>} rules={[{ required: true, message: "Please select sender" }]}>
                <Select 
                  placeholder="Select sender"
                  popupClassName="dark-select-dropdown"
                >
                  <Select.Option 
                    value="admin"
                    style={{ color: 'white', backgroundColor: 'transparent' }}
                  >
                    👨‍💼 Administrator
                  </Select.Option>
                  <Select.Option 
                    value="myanmar_labor"
                    style={{ color: 'white', backgroundColor: 'transparent' }}
                  >
                    🇲🇲 Myanmar Ministry of Labour
                  </Select.Option>
                  <Select.Option 
                    value="system"
                    style={{ color: 'white', backgroundColor: 'transparent' }}
                  >
                    🤖 System
                  </Select.Option>
                  <Select.Option 
                    value="operator"
                    style={{ color: 'white', backgroundColor: 'transparent' }}
                  >
                    🏛️ System Operator
                  </Select.Option>
                  <Select.Option 
                    value="support"
                    style={{ color: 'white', backgroundColor: 'transparent' }}
                  >
                    🆘 Support Team
                  </Select.Option>
                </Select>
              </Form.Item>
            </Col>
            <Col xs={24} md={12}>
              <Form.Item name="category" label={<span className="text-slate-700 font-medium">Category</span>}>
                <Select 
                  placeholder="Select category"
                  popupClassName="dark-select-dropdown"
                  allowClear
                >
                  <Select.Option 
                    value="general"
                    style={{ color: 'white', backgroundColor: 'transparent' }}
                  >
                    📢 General Notice
                  </Select.Option>
                  <Select.Option 
                    value="urgent"
                    style={{ color: 'white', backgroundColor: 'transparent' }}
                  >
                    🚨 Urgent Notice
                  </Select.Option>
                  <Select.Option 
                    value="policy"
                    style={{ color: 'white', backgroundColor: 'transparent' }}
                  >
                    📋 Policy Update
                  </Select.Option>
                  <Select.Option 
                    value="safety"
                    style={{ color: 'white', backgroundColor: 'transparent' }}
                  >
                    🛡️ Safety Information
                  </Select.Option>
                  <Select.Option 
                    value="remittance"
                    style={{ color: 'white', backgroundColor: 'transparent' }}
                  >
                    💰 Remittance
                  </Select.Option>
                  <Select.Option 
                    value="kyc"
                    style={{ color: 'white', backgroundColor: 'transparent' }}
                  >
                    🆔 KYC Process
                  </Select.Option>
                  <Select.Option 
                    value="system"
                    style={{ color: 'white', backgroundColor: 'transparent' }}
                  >
                    ⚙️ System Maintenance
                  </Select.Option>
                  <Select.Option 
                    value="holiday"
                    style={{ color: 'white', backgroundColor: 'transparent' }}
                  >
                    🎉 Holiday Notice
                  </Select.Option>
                  <Select.Option 
                    value="training"
                    style={{ color: 'white', backgroundColor: 'transparent' }}
                  >
                    📚 Training Program
                  </Select.Option>
                  <Select.Option 
                    value="event"
                    style={{ color: 'white', backgroundColor: 'transparent' }}
                  >
                    🎪 Event Announcement
                  </Select.Option>
                </Select>
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={12}>
            <Col xs={24} md={10}>
              <Form.Item name="priority" label={<span className="text-slate-700 font-medium">Priority</span>}>
                <Radio.Group size="small" optionType="button" buttonStyle="solid">
                  <Radio.Button value="low">Low</Radio.Button>
                  <Radio.Button value="normal">Normal</Radio.Button>
                  <Radio.Button value="high">High</Radio.Button>
                  <Radio.Button value="urgent">Urgent</Radio.Button>
                </Radio.Group>
              </Form.Item>
            </Col>
            <Col xs={24} md={9}>
              <Form.Item name="status" label={<span className="text-slate-700 font-medium">Status</span>}>
                <Radio.Group size="small" optionType="button" buttonStyle="solid">
                  <Radio.Button value="active">Active</Radio.Button>
                  <Radio.Button value="inactive">Hidden</Radio.Button>
                </Radio.Group>
              </Form.Item>
            </Col>
            <Col xs={24} md={5}>
              <Form.Item name="isUrgent" label={<span className="text-slate-700 font-medium">Urgent</span>} valuePropName="checked">
                <Switch 
                  checkedChildren="Urgent" 
                  unCheckedChildren="Normal"
                  checked={isUrgent}
                  onChange={(checked) => {
                    setIsUrgent(checked);
                    form.setFieldsValue({ isUrgent: checked });
                  }}
                  style={{ 
                    backgroundColor: isUrgent ? '#ff4d4f' : undefined,
                    borderColor: isUrgent ? '#ff4d4f' : undefined
                  }}
                />
              </Form.Item>
            </Col>
          </Row>

          <Form.Item name="tags" label={<span className="text-slate-700 font-medium">Tags</span>}>
            <Input 
              placeholder="Enter tags separated by commas (e.g., urgent, remittance, kyc)" 
              className="focus:border-slate-400 focus:ring-2 focus:ring-slate-200"
            />
          </Form.Item>

          <Form.Item label={<span className="text-slate-700 font-medium">Attachments</span>}>
            <Upload
              fileList={fileList}
              onChange={({ fileList }) => setFileList(fileList)}
              beforeUpload={() => false}
              multiple
            >
              <Button 
                icon={<PlusOutlined />}
                className="bg-white border-slate-200 text-slate-700 hover:border-slate-300"
              >
                Upload Files
              </Button>
            </Upload>
          </Form.Item>

          <Form.Item className="mb-0 pt-3 border-t border-slate-100">
            <Space className="w-full justify-end">
              <Button 
                type="primary" 
                htmlType="submit" 
                loading={uploading}
                onClick={async () => {
                  try {
                    const values = await form.validateFields();
                    await handleSubmit(values);
                  } catch (error) {
                    console.log('Form validation failed:', error);
                    safeShowToastMessage("필수 필드를 모두 입력해주세요.", "error");
                  }
                }}
                className="bg-slate-900 border-0 hover:bg-slate-800 shadow-sm"
              >
                {editingItem ? "Update" : "Create"}
              </Button>
              <Button 
                onClick={handleModalCancel}
                className="bg-white border-slate-200 text-slate-700 hover:border-slate-300"
              >
                Cancel
              </Button>
            </Space>
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default AdminNoticePage;

